import React from 'react';
import PropTypes from 'prop-types';

import { useWindowSize } from 'common/react/hooks/use-window-resize';
import { StatsSection } from 'widgets/statspro/js/components/common/stats-section';

import { Date } from './nav-items';
import { EventTypeFilter } from './nav-items/EventTypeFilter';
import { TeamFilter } from './nav-items/TeamFilter';

export const EventsListingNav = ({
    events,
    compseasonId,
    tags,
    localTimezone
}) => {
    const tagItems = tags
        ? tags.split(',').map((tag) => ({
              value: tag,
              name: tag.replace('EventType:', '')
          }))
        : [];

    const windowSize = useWindowSize();
    const isResponsive = windowSize.width < PULSE.app.measurements.desktop;

    return (
        <div className="events-listing-nav">
            <StatsSection.Main>
                <StatsSection.Nav showFilterItems={isResponsive}>
                    <StatsSection.NavItems>
                        <Date localTimezone={localTimezone} events={events} />
                    </StatsSection.NavItems>
                    <StatsSection.NavFilterItems
                        hideReset={true}
                        showFilterItems={isResponsive}
                    >
                        {tagItems.length && <EventTypeFilter tags={tagItems} />}
                        {compseasonId && (
                            <TeamFilter compseasonId={compseasonId} />
                        )}
                    </StatsSection.NavFilterItems>
                </StatsSection.Nav>
            </StatsSection.Main>
        </div>
    );
};

EventsListingNav.propTypes = {
    events: PropTypes.array.isRequired,
    compseasonId: PropTypes.string,
    tags: PropTypes.string,
    localTimezone: PropTypes.string
};
